import React, { useCallback, useEffect, useState } from "react";
import BuySellBtn from "../CommonTocComponent/Stock/BuySellBtn";
import MarginReqAvail from "../CommonTocComponent/Stock/MarginReqAvail";
import EqProductOrder from "./EqProductOrder";
import { chargesHandler, checkTocState, commonConverList, declarationMsg, fieldValidationManager, getProductValues, } from "../constant";
import StockQuote from "../CommonTocComponent/TocHeader/StockQuote";
import TocStockHeader from "../CommonTocComponent/TocHeader/TocStockHeader";
import MarketDepth from "../CommonTocComponent/MarketDepth/MarketDepth";
import ChargesMain from "../CommonTocComponent/Charges/ChargesMain";
import UnderStandingMain from "../CommonTocComponent/UnderstandSection/UnderStandingMain";
import OrderConfirmationMain from "../CommonTocComponent/OrderConfirmation/OrderConfirmationMain";
import { useSelector } from "react-redux";
import { placeorderData } from "../CommonTocComponent/MarketDepth/MarketDepthTabs";
import { EQTOCIgnoreList, SIPIgnoreList, TOCBUYORSELL, } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import di from "@frameworks/web/components/features/TOC/di/servicelocator";
import { CreateTOCbuttonList, orderData, productData, understandingSectionEnum, } from "../CommonTocComponent/commonTocConstant";
import { eqProducts, eqOrder, eqValidity, } from "./EqConstants";
import { Sellstock } from "../CommonTocComponent/sellstock";
import { AuthToSellJourney, setUISections, setUISectionsEquity, } from "./EqTOCFunctionality";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AuthoriseToSell from "../../../generic/TOCgeneric/AuthoriseToSell";
import Convert from "../CommonTocComponent/Convert/Convert";
import { EsipFrequency } from "../Esip/EsipConstant";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import { isEqual } from "underscore";
import { OrderbookTocStateEnum, } from "@frameworks/web/components/features/OrderBook/constant";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import UnderStanding from "../CommonTocComponent/UnderstandSection/UnderStanding";
import ChartIQTOC from "../CommonTocComponent/ChartIQ/ChartIQTOC";
import * as moment from "moment";
import { addCommasWithConditionalDecimal, } from "@domains/utils/numberMethods";
import { nextWorkingDay } from "@frameworks/web/utils/date";
const EqBuySellStock = (props) => {
    var _a, _b, _c, _d;
    const device = DeviceContext();
    const location = useLocation();
    const params = useParams();
    const action = getQueryParameterName("action");
    const locationState = location.state;
    const navigate = useNavigate();
    const quotesDetailsEntity = useSelector((state) => state.TOCJourney.multiQuoteReducers.multiQuote.quotesDetailsEntity, isEqual);
    const [termCondition, setTermCondition] = React.useState(false);
    const [understanding, setUnderstanding] = React.useState(false);
    const [marketDepth, setmarketDepth] = React.useState(false);
    const [charges, setCharges] = React.useState(false);
    const [confirmOrder, setConfirmOrder] = React.useState(false);
    const [convert, setConvert] = React.useState(false);
    const [chartIQ, setChartIQ] = React.useState(false);
    const [showAmount, setShowAmount] = useState();
    const [advancedOption, setAdvancedOption] = useState(false);
    const [modifySection, setModifySection] = useState({
        tocState: (locationState === null || locationState === void 0 ? void 0 : locationState.tocState) || (props === null || props === void 0 ? void 0 : props.tocState) || null,
        modifyData: (locationState === null || locationState === void 0 ? void 0 : locationState.modifyData) || (props === null || props === void 0 ? void 0 : props.modifyData) || {},
    });
    const [nseBse, setNseBse] = React.useState((quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0 && ((_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.exchange)
        ? (_b = quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.exchange
        : placeorderData[1].value);
    const [refreshMargin, setrefreshMargin] = useState(null);
    const [IsBuy, setIsBuy] = useState(() => device.isDesktop ? props === null || props === void 0 ? void 0 : props.isBuy : locationState === null || locationState === void 0 ? void 0 : locationState.isBuy);
    const [activeState, setActiveState] = useState(IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL);
    const [ProceedToAuthorize, setProceedToAuthorize] = React.useState(false);
    const [margin, setMargin] = React.useState(null);
    const [buttonList, setButtonList] = useState();
    const [orderType, setOrderType] = useState();
    const [validity, setValidity] = useState();
    const [amoOrder, setAmoOrder] = useState(null);
    const [underStandingSectionKey, setUnderStandingSectionKey] = useState(null);
    const [activeButton, setActiveButton] = useState({
        PRODUCT: eqProducts[0].value,
        ORDER: eqOrder[0].value,
        VALIDITY: eqValidity[0].value,
        FREQUENCY: EsipFrequency[0].title,
    });
    const [tradeValues, setTradeValues] = useState({
        amount: "0",
        limitPrice: "",
        stopLoss: "",
        target: "",
        triggerPrice: "",
        disclosedQuantity: "",
        quantity: "",
        agreeToTermsAndCondition: false,
        totalperiod: "1",
        startDate: moment(nextWorkingDay()).format("DD-MMM-YY"),
    });
    const [formErrors, setFormErrors] = useState({
        limitPrice: { msg: "", status: false },
        triggerPrice: { msg: "", status: false },
        amount: { msg: "", status: false },
        stopLoss: { msg: "", status: false },
        target: { msg: "", status: false },
        disclosedQuantity: { msg: "", status: false },
        quantity: { msg: "", status: false },
        totalperiod: { msg: "", status: false },
        startDate: { msg: "", status: false },
    });
    const [orderConfirmationList, setOrderConfirmationList] = useState(null);
    const [orderEsipConfirmationList, setOrderEsipConfirmationList] = useState(null);
    const [authToSell, setAuthToSell] = useState(false);
    const [authToSellDisableSell, setAuthToSellDisableSell] = useState(false);
    const rmsDetails = useSelector((state) => state.TOCJourney.rmsDetails, isEqual);
    const rmsSublimits = rmsDetails.rmsSublimits;
    const { data: checkMarginData, loader: checkMarginLoader, errorData: checkMarginError, } = useSelector((state) => state.TOCJourney.checkMargin, isEqual);
    const { data: amo, loader: amoLoader, errorData: amoError, } = useSelector((state) => state.TOCJourney.AMOStatus, isEqual);
    const { userID: userID } = useSelector((state) => state.accountDetailsReducer, isEqual);
    const getRmssSublimitsData = () => {
        if (userID)
            di.tocJourney.getRmsSublimits(userID);
    };
    const { data: proceedToAuth, loader: proceedToAuthLoader, errorData: proceedToAuthError, } = useSelector((state) => state.TOCJourney.proceedToAuth, isEqual);
    const actionTypeHandler = (state) => {
        setActiveState(state);
        amoSelecterHandler(amoOrder, "", state);
    };
    const handleConfirmPage = useCallback(() => {
        return (React.createElement(OrderConfirmationMain, { setConfirmOrder: confirmOrderLoader, show: confirmOrder, orderConfirmationList: activeState === TOCBUYORSELL.SIP
                ? orderEsipConfirmationList
                : orderConfirmationList, exchange: nseBse, action: activeState, activeButton: activeButton, tradeValues: tradeValues, amoOrder: amoOrder, closeToc: closeTOC, tocState: modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, modifyData: modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData, afterModifyAction: props === null || props === void 0 ? void 0 : props.afterModifyAction, afterMarketRedirect: locationState === null || locationState === void 0 ? void 0 : locationState.redirectUrl, showAmount: showAmount, buttonList: buttonList, declarationMsg: activeState === TOCBUYORSELL.SIP &&
                (activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) == eqProducts[1].title
                ? declarationMsg.esipNrmlConsent
                : "" }));
    }, [confirmOrder]);
    const confirmOrderLoader = async (val) => {
        if (val) {
            await di.tocJourney.flushPlaceOrderError();
            await di.tocJourney.flushPlaceOrderData();
            setConfirmOrder(val);
        }
        else {
            setConfirmOrder(val);
        }
    };
    const getRmsHoldingsData = () => {
        const req = {
            userId: userID,
            symbol: quotesDetailsEntity ? quotesDetailsEntity[0].symbol : "",
        };
        if (userID)
            di.tocJourney.getRmsHoldingDetails(req);
    };
    const getChargesData = () => {
        var _a;
        const req = {
            userID: userID,
            reqBody: {
                action: activeState,
                prd: getProductValues(buttonList, activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT),
                price: tradeValues.limitPrice,
                qty: tradeValues.quantity,
                sym: (_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.symbol,
            },
        };
        di.tocJourney.brokerCharge(req);
    };
    const updateMargin = () => {
        di.tocJourney.checkMargin(refreshMargin);
    };
    const proceedToPlaceOrder = () => {
        createFormErrorFields(true)
            .then((data) => {
            setFormErrors(data);
            if (Object.values(data)
                .map((x) => x.status)
                .some((x) => x)) {
                disableSell();
            }
            else {
                updateMargin();
                confirmOrderLoader(true);
            }
        })
            .catch((err) => { });
    };
    const CreatebuttonList = async (isAmo, isBOSelected, isModify, modifyData, actionType) => {
        let ignoreList = isAmo ? [...EQTOCIgnoreList, "BO"] : EQTOCIgnoreList;
        if (actionType && actionType === TOCBUYORSELL.SIP) {
            return await CreateTOCbuttonList(nseBse, SIPIgnoreList);
        }
        else {
            return await CreateTOCbuttonList(nseBse, ignoreList, isAmo, isModify, modifyData, isBOSelected);
        }
    };
    const amoSelecterHandler = async (val, textContent, actionType) => {
        var _a, _b;
        await setAmoOrder(val);
        let isModify = (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
            ? checkTocState(locationState === null || locationState === void 0 ? void 0 : locationState.tocState, OrderbookTocStateEnum.MODIFY)
            : (props === null || props === void 0 ? void 0 : props.tocState)
                ? checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                : false;
        let isBOOrder = textContent === eqProducts[4].title;
        let buttonList = await CreatebuttonList(val, isBOOrder, isModify, modifySection.modifyData, actionType);
        await setButtonList(buttonList === null || buttonList === void 0 ? void 0 : buttonList.products);
        await setOrderType(buttonList === null || buttonList === void 0 ? void 0 : buttonList.orderType);
        await setValidity(buttonList === null || buttonList === void 0 ? void 0 : buttonList.validity);
        if (val) {
            await setActiveButton(Object.assign(Object.assign({}, activeButton), { ORDER: (_a = eqOrder[1]) === null || _a === void 0 ? void 0 : _a.title }));
            if (activeButton.PRODUCT === eqProducts[4].value) {
                await setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: eqProducts[0].title }));
            }
        }
        if (textContent) {
            await setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: textContent, ORDER: textContent == eqProducts[4].value
                    ? (_b = eqOrder[1]) === null || _b === void 0 ? void 0 : _b.title
                    : activeButton.ORDER }));
        }
    };
    const removeMarginData = () => {
        tocDi.tocJourney.flushMarginData();
    };
    const closeTOC = () => {
        removeMarginData();
        !device.isDesktop ? navigate(-1) : props.setShowTOC(false);
    };
    const disableSell = () => {
        if (activeState === TOCBUYORSELL.SIP) {
            return !tradeValues.agreeToTermsAndCondition ||
                tradeValues.startDate == "" ||
                Number(tradeValues.totalperiod) <= 0 ||
                !(Number(tradeValues.quantity) > 0 || Number(tradeValues.amount) > 0)
                ? true
                : false;
        }
        else {
            return ((activeButton.PRODUCT === eqProducts[4].title &&
                !tradeValues.agreeToTermsAndCondition) ||
                !activeButton.ORDER ||
                !activeButton.PRODUCT ||
                !(Number(tradeValues.quantity) > 0 || Number(tradeValues.amount) > 0) ||
                Object.values(formErrors)
                    .map((x) => x.status)
                    .some((x) => x) ||
                !quotesDetailsEntity ||
                (authToSell && authToSellDisableSell) ||
                (!proceedToAuthLoader &&
                    proceedToAuthError.isOpen &&
                    proceedToAuthError.error.getErrCd() === "EGN0001"));
        }
    };
    const createFormErrorFields = async (isSubmit) => {
        return new Promise((res, error) => {
            let getUIstatus = setUISectionsEquity(activeButton);
            let isModify = checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY);
            const validation = fieldValidationManager(tradeValues, activeState, quotesDetailsEntity[0]);
            res({
                limitPrice: !(getUIstatus === null || getUIstatus === void 0 ? void 0 : getUIstatus.disabledLimitInput)
                    ? isSubmit
                        ? validation.getLimitValidation
                        : !tradeValues.limitPrice
                            ? { msg: "", status: true }
                            : validation.getLimitValidation
                    : { msg: "", status: false },
                triggerPrice: getUIstatus.showTriggerPrice
                    ? isSubmit
                        ? validation.getTriggerValidation
                        : !tradeValues.triggerPrice
                            ? { msg: "", status: true }
                            : validation.getTriggerValidation
                    : { msg: "", status: false },
                stopLoss: getUIstatus.showStopLoss
                    ? isSubmit
                        ? validation.getStoplossValidation
                        : !tradeValues.stopLoss && !isModify
                            ? { msg: "", status: true }
                            : validation.getStoplossValidation
                    : { msg: "", status: false },
                target: getUIstatus.showTargetPrice
                    ? isSubmit
                        ? validation.getTargetValidation
                        : !tradeValues.target && !isModify
                            ? { msg: "", status: true }
                            : validation.getTargetValidation
                    : { msg: "", status: false },
                amount: showAmount
                    ? (isSubmit || !!(formErrors === null || formErrors === void 0 ? void 0 : formErrors.amount)) &&
                        (!tradeValues.amount || tradeValues.amount == "0")
                        ? { msg: "Amount can not be blank or 0", status: true }
                        : !tradeValues.amount
                            ? { msg: "", status: true }
                            : formErrors === null || formErrors === void 0 ? void 0 : formErrors.stopLoss
                    : { msg: "", status: false },
                disclosedQuantity: isSubmit || !!(formErrors === null || formErrors === void 0 ? void 0 : formErrors.disclosedQuantity)
                    ? validation.getDisclossValidation
                    : { msg: "", status: false },
                quantity: !showAmount && !tradeValues.quantity
                    ? { msg: "", status: true }
                    : { msg: "", status: false },
                totalperiod: activeState === TOCBUYORSELL.SIP && !tradeValues.totalperiod
                    ? { msg: "", status: true }
                    : { msg: "", status: false },
                startDate: activeState === TOCBUYORSELL.SIP && !tradeValues.startDate
                    ? { msg: "", status: true }
                    : { msg: "", status: false },
            });
        });
    };
    const updateModifiedData = React.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            amount: "0",
            limitPrice: ((_a = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _a === void 0 ? void 0 : _a.limitPrice)
                ? (_b = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _b === void 0 ? void 0 : _b.limitPrice
                : "",
            triggerPrice: ((_c = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _c === void 0 ? void 0 : _c.triggerPrice)
                ? (_d = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _d === void 0 ? void 0 : _d.triggerPrice
                : "",
            disclosedQuantity: +((_e = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _e === void 0 ? void 0 : _e.discloseQty) > 0
                ? (_f = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _f === void 0 ? void 0 : _f.discloseQty
                : "",
            quantity: ((_g = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _g === void 0 ? void 0 : _g.netQty)
                ? (_h = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _h === void 0 ? void 0 : _h.netQty
                : "",
            agreeToTermsAndCondition: false,
            stopLoss: "",
            target: "",
            totalperiod: "",
            startDate: "",
        };
    }, [modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData]);
    React.useEffect(() => {
        var _a, _b, _c;
        if (nseBse &&
            (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0 &&
            nseBse !== ((_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.exchange) &&
            ((_b = quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.asSymbol)) {
            tocDi.tocJourney.getMultiQuoteData({
                symLst: [(_c = quotesDetailsEntity[0]) === null || _c === void 0 ? void 0 : _c.asSymbol],
            });
        }
    }, [nseBse]);
    useEffect(() => {
        if ((device === null || device === void 0 ? void 0 : device.isMobile) && (params === null || params === void 0 ? void 0 : params.symbol) && !quotesDetailsEntity) {
            di.tocJourney.getMultiQuoteData({
                symLst: [params === null || params === void 0 ? void 0 : params.symbol],
            });
        }
    }, [params === null || params === void 0 ? void 0 : params.symbol]);
    React.useEffect(() => {
        if (action !== null && action !== undefined && action !== "") {
            if (action === "Buy") {
                setActiveState(TOCBUYORSELL.BUY);
            }
            else {
                setActiveState(TOCBUYORSELL.SELL);
            }
        }
    }, [action]);
    React.useEffect(() => {
        if (quotesDetailsEntity &&
            (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0 &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState)) {
            setTradeValues(Object.assign(Object.assign({}, tradeValues), { limitPrice: quotesDetailsEntity[0].lastTradedPrice }));
            getRmsHoldingsData();
        }
    }, [quotesDetailsEntity]);
    useEffect(() => {
        var _a;
        if ((_a = rmsDetails === null || rmsDetails === void 0 ? void 0 : rmsDetails.rmsHolding) === null || _a === void 0 ? void 0 : _a.sts) {
            let authToSell = AuthToSellJourney(activeButton, activeState);
            (async () => {
                let resp = await authToSell.shouldGoTOAuth(rmsDetails);
                setAuthToSell(resp);
            })();
            (async () => {
                let resp = await authToSell.disableSell(rmsDetails);
                setAuthToSellDisableSell(resp);
            })();
        }
    }, [activeButton, activeState, rmsDetails]);
    useEffect(() => {
        getRmssSublimitsData();
        updateMargin();
        if (!device.isDesktop && location && (locationState === null || locationState === void 0 ? void 0 : locationState.Authsymbol)) {
            AuthToSellJourney().multiquote(location, locationState === null || locationState === void 0 ? void 0 : locationState.Authsymbol);
        }
        if (localStorage.getItem("acc_data") &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState)) {
            CreatebuttonList(amoOrder).then((list) => {
                setButtonList(list === null || list === void 0 ? void 0 : list.products);
                setOrderType(list === null || list === void 0 ? void 0 : list.orderType);
                setValidity(list === null || list === void 0 ? void 0 : list.validity);
            });
        }
    }, []);
    useEffect(() => {
        !checkMarginLoader &&
            !checkMarginError.isOpen &&
            setMargin(checkMarginData);
    }, [checkMarginData, checkMarginLoader, checkMarginError]);
    useEffect(() => {
        if (!amoLoader &&
            !amoError.isOpen &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState)) {
            amoSelecterHandler(amo === null || amo === void 0 ? void 0 : amo.status, "", activeState);
        }
    }, [amo, amoLoader, amoError]);
    React.useEffect(() => {
        if (activeButton && (!(props === null || props === void 0 ? void 0 : props.tocState) || !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState))) {
            createFormErrorFields().then((data) => {
                setFormErrors(data);
            });
        }
    }, [activeButton, activeState, showAmount, advancedOption]);
    useEffect(() => {
        var _a, _b, _c;
        if (margin && activeButton && tradeValues) {
            if (activeState === TOCBUYORSELL.SIP) {
                setOrderEsipConfirmationList([
                    {
                        title: "Action",
                        value: activeState === "SIP" ? "ESIP" : activeState,
                    },
                    {
                        title: "Product type",
                        value: (_a = buttonList === null || buttonList === void 0 ? void 0 : buttonList.find((x) => x.title === (activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT))) === null || _a === void 0 ? void 0 : _a.value,
                    },
                    {
                        title: "Frequency",
                        value: activeButton === null || activeButton === void 0 ? void 0 : activeButton.FREQUENCY,
                    },
                    {
                        title: "Quantity",
                        value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.quantity),
                    },
                    {
                        title: "Total Period (months)",
                        value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.totalperiod),
                    },
                    { title: "Start Date", value: tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.startDate },
                ]);
            }
            else {
                setOrderConfirmationList([
                    {
                        title: "Action",
                        value: activeState,
                    },
                    {
                        title: "Product type",
                        value: (_b = buttonList === null || buttonList === void 0 ? void 0 : buttonList.find((x) => x.title === (activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT))) === null || _b === void 0 ? void 0 : _b.value,
                    },
                    {
                        title: "Order type",
                        value: (_c = orderType === null || orderType === void 0 ? void 0 : orderType.find((x) => x.title === (activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER))) === null || _c === void 0 ? void 0 : _c.title,
                    },
                    {
                        title: "Quantity",
                        value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.quantity),
                    },
                    {
                        title: "Limit price",
                        value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.limitPrice),
                        isHide: setUISections(activeButton, true).disabledLimitInput,
                    },
                    {
                        title: "Trigger price",
                        value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.triggerPrice),
                        isHide: !setUISections(activeButton, true).showTriggerPrice,
                    },
                    {
                        title: "Stop Loss",
                        value: `-${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.stopLoss)} pts`,
                        isHide: !setUISections(activeButton, true).showStopLoss,
                    },
                    {
                        title: "Target",
                        value: `+${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.target)} pts`,
                        isHide: !setUISections(activeButton, true).showTargetPrice,
                    },
                ]);
            }
        }
    }, [activeState, activeButton, tradeValues]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (updateModifiedData && ((props === null || props === void 0 ? void 0 : props.tocState) || (locationState === null || locationState === void 0 ? void 0 : locationState.tocState))) {
            setTradeValues(updateModifiedData);
            setNseBse(((_a = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _a === void 0 ? void 0 : _a.exchange)
                ? (_b = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _b === void 0 ? void 0 : _b.exchange
                : nseBse);
            createFormErrorFields().then((data) => {
                setFormErrors(data);
            });
            let isModify = (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
                ? checkTocState(locationState === null || locationState === void 0 ? void 0 : locationState.tocState, OrderbookTocStateEnum.MODIFY)
                : (props === null || props === void 0 ? void 0 : props.tocState)
                    ? checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                    : false;
            let modifyData = (locationState === null || locationState === void 0 ? void 0 : locationState.modifyData)
                ? locationState === null || locationState === void 0 ? void 0 : locationState.modifyData
                : props === null || props === void 0 ? void 0 : props.modifyData;
            setModifySection({
                tocState: (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
                    ? locationState === null || locationState === void 0 ? void 0 : locationState.tocState
                    : props === null || props === void 0 ? void 0 : props.tocState,
                modifyData: modifyData,
            });
            setAmoOrder((_c = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _c === void 0 ? void 0 : _c.isAmo);
            let isBOOrder = (modifyData === null || modifyData === void 0 ? void 0 : modifyData.productType) == eqProducts[4].title;
            CreatebuttonList((_d = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _d === void 0 ? void 0 : _d.isAmo, isBOOrder, isModify, modifyData).then((list) => {
                setButtonList(list === null || list === void 0 ? void 0 : list.products);
                setOrderType(list === null || list === void 0 ? void 0 : list.orderType);
                setValidity(list === null || list === void 0 ? void 0 : list.validity);
            });
            setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: (_e = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _e === void 0 ? void 0 : _e.productType, ORDER: (_f = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _f === void 0 ? void 0 : _f.orderType, VALIDITY: (_g = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _g === void 0 ? void 0 : _g.validity }));
        }
    }, [updateModifiedData]);
    return (React.createElement(React.Fragment, null, convert ? (React.createElement(Convert, { show: convert, setShow: setConvert, activeState: activeState, setActiveState: actionTypeHandler, convertList: commonConverList })) : confirmOrder ? (React.createElement(React.Fragment, null, handleConfirmPage())) : charges ? (React.createElement(ChargesMain, { show: charges, setShow: setCharges })) : marketDepth ? (React.createElement(MarketDepth, { setmarketDepth: setmarketDepth, show: marketDepth, setNseBse: setNseBse, nseBse: nseBse })) : chartIQ ? (React.createElement(ChartIQTOC, { symbol: quotesDetailsEntity ? quotesDetailsEntity[0].symbol : "", instru: quotesDetailsEntity ? quotesDetailsEntity[0].asTyp : "", show: chartIQ, goBack: () => setChartIQ(false) })) : (React.createElement(React.Fragment, null, understanding ? (React.createElement(UnderStandingMain, { show: understanding, setShow: setUnderstanding, content: React.createElement(GenericTabs, { defaultActiveKey: underStandingSectionKey, tabsArray: [
                {
                    title: "Product Type",
                    eventKey: understandingSectionEnum.PRODUCT,
                    tabContent: (React.createElement(UnderStanding, { data: productData, activeKey: activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT })),
                },
                activeState !== (TOCBUYORSELL === null || TOCBUYORSELL === void 0 ? void 0 : TOCBUYORSELL.SIP) && {
                    title: "Order Type",
                    eventKey: understandingSectionEnum.ORDER,
                    tabContent: (React.createElement(UnderStanding, { data: orderData, activeKey: activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER })),
                },
            ] }) })) : ProceedToAuthorize && authToSell ? (React.createElement(AuthoriseToSell, { setProceedToAuthorize: setProceedToAuthorize })) : (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(StockQuote, { stockQuoteDetails: quotesDetailsEntity, setNseBse: setNseBse, exchangeType: nseBse, setChartIQ: () => setChartIQ(true), multiToggle: (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0 &&
                    !!((_c = quotesDetailsEntity[0]) === null || _c === void 0 ? void 0 : _c.asExchange)
                    ? true
                    : false, textInsteadToggle: (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0 &&
                    !!((_d = quotesDetailsEntity[0]) === null || _d === void 0 ? void 0 : _d.asExchange)
                    ? false
                    : true, isModifyOrder: checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY) }) }),
        React.createElement(EqProductOrder, { setTermCondition: setTermCondition, setUnderstanding: setUnderstanding, setUnderStandingSectionKey: setUnderStandingSectionKey, setmarketDepth: setmarketDepth, multiQuoteEntity: (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0
                ? quotesDetailsEntity[0]
                : {}, setrefreshMargin: setrefreshMargin, activeState: activeState, buttonList: buttonList, orderType: orderType, validity: validity, setActiveButton: setActiveButton, activeButton: activeButton, tradeValues: tradeValues, setTradeValues: setTradeValues, amoOrder: amoOrder, setAmoOrder: amoSelecterHandler, margin: margin, setFormErrors: setFormErrors, formErrors: formErrors, showAmount: showAmount, setShowAmount: setShowAmount, advancedOption: advancedOption, setAdvancedOption: setAdvancedOption, isModifyOrder: checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY), modifyData: modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData }),
        React.createElement("div", { className: "bottom-contents" }, authToSell ? (React.createElement(Sellstock, { setProceedToAuthorize: setProceedToAuthorize })) : (React.createElement("div", null,
            React.createElement(MarginReqAvail, { hideCharges: activeState == (TOCBUYORSELL === null || TOCBUYORSELL === void 0 ? void 0 : TOCBUYORSELL.SIP), setCharges: setCharges, getChargesData: getChargesData, updateMargin: updateMargin, margin: margin, disableCharges: chargesHandler(tradeValues), availableCash: rmsSublimits.cshAvl, loader: checkMarginLoader }),
            React.createElement(BuySellBtn, { refreshLabelTitle: "Convert", mobRefresh: device === null || device === void 0 ? void 0 : device.isMobile, buySellRefresh: (modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState)
                    ? checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.DEFAULT)
                    : true, isModify: checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY), cancelAction: closeTOC, rightButton: {
                    btnTyp: activeState === TOCBUYORSELL.SELL
                        ? "red-btn"
                        : "green-btn",
                    value: checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY)
                        ? "Modify"
                        : activeState === TOCBUYORSELL.SIP
                            ? "Start ESIP"
                            : activeState,
                    className: "w-100",
                    onClick: () => proceedToPlaceOrder(),
                    disabled: disableSell(),
                }, setConvert: setConvert }))))))))));
};
export default EqBuySellStock;
